import React from "react";
import MasterModule from "../MasterModule";
import Warehouse from "./Warehouse";
import OperationStages from "./OperationStages";
import { ERP_AUTH } from "../../../config/authorizationConfig";

// Module configuration
const erpModules = [
  {
    name: "Warehouse",
    component: Warehouse,
    authConfig: ERP_AUTH.MANAGE_WAREHOUSE,
  },
  {
    name: "Operation Stages (Product Manufacturing Stages)",
    component: OperationStages,
    authConfig: ERP_AUTH.MANAGE_OPERATION_STAGES,
  },
];

// API endpoints mapping
const erpApiEndpoints = {
  Warehouse: "/warehouses",
  "Operation Stages (Product Manufacturing Stages)": "/operation-categories",
};

// Custom URL builder for ERP
const getErpApiUrl = (endpoint) => {
  return `${process.env.REACT_APP_API_ERP_ADMIN_URL}${endpoint}`;
};

const ErpMaster = () => {
  return (
    <MasterModule
      title="ERP Modules"
      modules={erpModules}
      apiEndpoints={erpApiEndpoints}
      getApiUrl={getErpApiUrl}
    />
  );
};

export default ErpMaster;
